import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import ReactGA from 'react-ga4';
import { useSettings } from '../context/SettingsContext';

const Analytics = () => {
  const { settings } = useSettings();
  const location = useLocation();
  const initialized = useRef(false);
  const gaId = settings.google_analytics_id;

  // Initialize GA4 once when ID is available
  useEffect(() => {
    if (gaId && !initialized.current) {
      ReactGA.initialize(gaId);
      initialized.current = true;
    }
  }, [gaId]);

  // Send pageview on every route change
  useEffect(() => {
    if (initialized.current) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }
  }, [location]);

  return null;
};

export default Analytics;
